import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import english from './ui-component/switchLanguage/locales/english.json';
import hindi from './ui-component/switchLanguage/locales/hindi.json';
import chinese from './ui-component/switchLanguage/locales/chinese.json';
import russian from './ui-component/switchLanguage/locales/russian.json';
import spanish from './ui-component/switchLanguage/locales/spanish.json';
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      english: { translation: english },
      hindi: { translation: hindi },
      chinese: { translation: chinese },
      russian: { translation: russian },
      spanish: { translation: spanish }
    },
    fallbackLng: 'english',
    interpolation: { escapeValue: false }
  });
export default i18n;